import { SUBCLUSTERS } from '../subclusters.js';

const CONSTRUCTION_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CONSTRUCTION_SCHEDULING,
        },
        {
            key: SUBCLUSTERS.CONSTRUCTION_PLANNING,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
    mini_site: {
        logo: {
            alt: 'monday.com for construction',
            url: '/construction',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/mini%20sites/construction/construction_minisite_Logo_Homepage.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/mini%20sites/construction/construction_minisite_Logo_Mobile.png',
            useDesktopLogoInMobile: 'true',
        },
        links: [
            {
                url: '/construction',
                text: 'minisite.header.overview',
                removeFromUnified: 'true',
            },
            {
                url: '/templates/category/construction',
                text: 'minisite.header.templates',
            },
            {
                url: '/construction/resources',
                text: 'minisite.header.resources',
            },
            {
                url: '/blog/construction',
                text: 'minisite.header.blog',
            },
        ],
        unifiedDesktopLogo: {
            url: '/construction',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/mini%20sites/construction/construction_minisite_Logo_Homepagecolor.png',
            alt: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/mini%20sites/construction/construction_minisite_Logo_Homepagecolor.png',
        },
    },
};

export { CONSTRUCTION_CLUSTER };
